/** ANCHOR: vk-group-announcement-modal — константы (удалить вместе с модалкой). */

export const VK_GROUP_ANNOUNCEMENT_STORAGE_KEY = 'mw_vk_group_announcement_shown_v1';

export const VK_GROUP_URL = 'https://vk.com/matchwear';

/** Сжатый баннер (см. scripts/compress_notification_image.py). */
export const VK_GROUP_ANNOUNCEMENT_IMAGE = 'vk-announce.webp';

export const VK_GROUP_ANNOUNCEMENT_MESSAGE =
  'Мы теперь в VK — если с Telegram что-то пойдёт не так, актуальные новости по MatchWear ищите здесь.';

export function wasVkGroupAnnouncementShown() {
  try {
    return localStorage.getItem(VK_GROUP_ANNOUNCEMENT_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markVkGroupAnnouncementShown() {
  try {
    localStorage.setItem(VK_GROUP_ANNOUNCEMENT_STORAGE_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
}
